import React, {useEffect, useState} from 'react';
import SideNavbar from '../../Components/SideNavbar'
import './CSS/Applications.css';

import vizeIcon from '../../Assets/Images/vize-logo-large.png';
import wordLogo from '../../Assets/Images/word.png';
import teamsLogo from '../../Assets/Images/teams.png';
import outlookLogo from '../../Assets/Images/outlook.png';


const Applications: React.FC = () => {

    const [isChargebeePaid, setIsChargebeePaid] = useState<string | null>(null);
    useEffect(() => {
        const storedIsChargebeePaid = localStorage.getItem('isChargebeePaid');

        setIsChargebeePaid(storedIsChargebeePaid);
    }, []);


    return (
        <div className="apps-page">
            <SideNavbar />
            <div className="apps-content">
                <h1 className="apps-title">Vize Apps</h1>
                <div className="app-list">
                    <div className="app-card">
                        <div className="app-icon">
                            <img src={vizeIcon} alt="vize-icon"/>
                        </div>
                        <div className="app-details">
                            <h2 className="app-name">VIZEdi Desktop Application</h2>
                            <p className="app-description">
                                VIZEdi allows users to track their non-inclusive word usage and provide real-time
                                alternatives.
                            </p>
                        </div>
                        {isChargebeePaid === 'true' ? (
                            <a
                                href="https://getvizedi.com/downloads/VIZEdi-setup.exe"
                                className="install-button"
                                download
                            >
                                Install
                            </a>
                        ) : (
                            <button className="install-button" disabled>
                                Install (Requires Payment)
                            </button>
                        )}
                    </div>

                    {/*<div className="app-card">*/}
                    {/*    <div className="app-icon">*/}
                    {/*        <img src={wordLogo} alt="word icon"/>*/}
                    {/*    </div>*/}
                    {/*    <div className="app-details">*/}
                    {/*        <h2 className="app-name">VIZEdi Addin for Word</h2>*/}
                    {/*        <p className="app-description">*/}
                    {/*            VIZEdi allows users to track there non-inclusive word usage and give real time*/}
                    {/*            alternatives.*/}
                    {/*        </p>*/}
                    {/*    </div>*/}
                    {/*    <a href="/manifests/Outlook/manifest.xml" className="install-button" download>*/}
                    {/*        Install*/}
                    {/*    </a>*/}
                    {/*</div>*/}

                    {/*<div className="app-card">*/}
                    {/*    <div className="app-icon">*/}
                    {/*        <img src={outlookLogo} alt="outlook icon"/>*/}
                    {/*    </div>*/}
                    {/*    <div className="app-details">*/}
                    {/*        <h2 className="app-name">VIZEdi Addin for Outlook</h2>*/}
                    {/*        <p className="app-description">*/}
                    {/*            VIZEdi allows users to track there non-inclusive word usage and give real time alternatives.*/}
                    {/*        </p>*/}
                    {/*    </div>*/}
                    {/*    <a href="/manifests/Word/manifest.xml" className="install-button" download>*/}
                    {/*        Install*/}
                    {/*    </a>*/}
                    {/*</div>*/}

                    {/*<div className="app-card">*/}
                    {/*    <div className="app-icon">*/}
                    {/*        <img src={teamsLogo} alt="teams logo"/>*/}
                    {/*    </div>*/}
                    {/*    <div className="app-details">*/}
                    {/*        <h2 className="app-name">VIZEdi Teams Application</h2>*/}
                    {/*        <p className="app-description">*/}
                    {/*            VIZEdi allows users to track there non-inclusive word usage and give real time*/}
                    {/*            alternatives.*/}
                    {/*        </p>*/}
                    {/*    </div>*/}
                    {/*    <a href="/manifests/Teams/teams-prod.zip" className="install-button" download>*/}
                    {/*        Install*/}
                    {/*    </a>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    );
};

export default Applications;
